import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IStocktakingNotScannedAssetsRouteParams {
    stocktakingId: Guid
    warehouseId: Guid
}

const StocktakingNotScannedAssetsRoute = new AppRoute<IStocktakingNotScannedAssetsRouteParams>({
    route: "/stocktakings/:stocktakingId/warehouse/:warehouseId/not-scanned-assets",
    navbar: true,
    authRequired: true,
})

export default StocktakingNotScannedAssetsRoute
